// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SNzJu","content":"styles_content__2Qwna","row":"styles_row__Wf9_v","footer":"styles_footer__QktId","phraseLength":"styles_phraseLength__3L5Mc"};